export const otherLang = (l) => (l === "en" ? "ar" : "en");

export function pick(rec, base, lang) {
  const own = (rec?.[`${base}_${lang}`] || "").trim();
  if (own) return { text: own, lang, fallback: false };
  const alt = (rec?.[`${base}_${otherLang(lang)}`] || "").trim();
  return { text: alt, lang: otherLang(lang), fallback: !!alt };
}

export const txt = (rec, base, lang) => pick(rec, base, lang).text;

export function formatPrice(value, lang, currency, arabicDigits) {
  const locale = lang === "ar" ? (arabicDigits ? "ar-SA" : "ar-SA-u-nu-latn") : "en-US";
  const frac = Number.isInteger(value) ? 0 : 2;
  try {
    return new Intl.NumberFormat(locale, { style: "currency", currency, minimumFractionDigits: frac, maximumFractionDigits: 2 }).format(value);
  } catch {
    return `${value} ${currency}`;
  }
}

export const ITEM_FIELDS = ["title", "description"];
export const CAT_FIELDS = ["name", "description"];

export function missingFields(rec, fields) {
  const res = { en: [], ar: [] };
  fields.forEach((f) => ["en", "ar"].forEach((l) => {
    if (!(rec?.[`${f}_${l}`] || "").trim()) res[l].push(f);
  }));
  return res;
}

export const isComplete = (rec, fields) => {
  const m = missingFields(rec, fields);
  return !m.en.length && !m.ar.length;
};
